/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Emails_Date_TimeInputs */

const en_emails_date_time = /** @type {(inputs: Emails_Date_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date / Time (UTC)`)
};

/**
* | output |
* | --- |
* | "Date / Time (UTC)" |
*
* @param {Emails_Date_TimeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const emails_date_time = /** @type {((inputs?: Emails_Date_TimeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Emails_Date_TimeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_emails_date_time(inputs)
});